import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { LicenseService } from 'src/app/services/license/license.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-add-subscription-license-route',
  templateUrl: './add-subscription-license-route.component.html',
  styleUrls: ['./add-subscription-license-route.component.css']
})
export class AddSubscriptionLicenseRouteComponent extends BaseComponent implements OnInit {
  customer_id;
  addRouteForm: FormGroup;
  getCompanyobj: any = [];
  licenseObj: any = [];
  actionOptions = ['view', 'add', 'edit', 'delete', 'execute'];
  submitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private licenseService: LicenseService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.addRouteForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? this.getDefaultCompanyId() : this.customer_id, Validators.required],
      license_id: ['', Validators.required],
      full_route: ['', [Validators.required, Validators.maxLength(500)]],
      component_name: ['', Validators.maxLength(200)],
      action: ['view', Validators.required],
      also_in_licenses: ['', Validators.maxLength(200)],
      component_file: ['', Validators.maxLength(500)],
      source_file: ['', Validators.maxLength(500)]
    });
    if (this.addRouteForm.value.selectedCompany) {
      this.loadLicenses(this.addRouteForm.value.selectedCompany);
    }
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      const working = self.bindWorkingCompany(self.getCompanyobj);
      if (working && !self.addRouteForm.value.selectedCompany) {
        self.addRouteForm.patchValue({ selectedCompany: working });
        self.loadLicenses(working);
      }
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange() {
    this.addRouteForm.patchValue({ license_id: '' });
    this.loadLicenses(this.addRouteForm.value.selectedCompany);
  }
  loadLicenses(companyId?) {
    const company = companyId || this.addRouteForm.value.selectedCompany;
    this.licenseObj = [];
    if (!company) {
      return;
    }
    this.ngxSpinnerService.show();
    this.licenseService.gettingLicense(company).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status && data.data) {
        this.licenseObj = data.data;
      } else {
        this.licenseObj = [];
      }
    }, error => {
      console.log(error);
      this.licenseObj = [];
      this.ngxSpinnerService.hide();
    });
  }
  get f() { return this.addRouteForm.controls; }
  addNewRoute() {
    this.submitted = true;
    if (this.addRouteForm.invalid) {
      return;
    }
    const { selectedCompany } = this.addRouteForm.value;
    this.ngxSpinnerService.show();
    this.masterService.addLicenseRoute(this.addRouteForm.value, selectedCompany).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License route added successfully');
        this.router.navigateByUrl('/corporate/subscription-license-route-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
